import {gsap} from "gsap";

let userMovie1 = new Vue({
    el: '#section-5',
    data() {
        return {
            currentIdx: 0,
            dom: {
              listItem: '',
              listItemLink: '#userMovieList .sec-movie__list__link'
            },
            userMovieData: userMovieData
        }
    },
    mounted: function () {
        this.$swiper = new Swiper("#userMovieList", {
            slidesPerView: 6,
            slidesPerGroup: 6,
            loop: true,
            loopFillGroupWithBlank: false,
            allowTouchMove: false,
            observer: true,
            observeParents: true,
            breakpoints: {
                1320: {
                    slidesPerView: 5,
                    slidesPerGroup: 5
                }
            },
            on: {
                init: () => {
                    this.setCurrent(this.currentIdx);
                    this.setContent(this.currentIdx);
                    this.setEvent();
                }
            }
        });
    },
    methods: {
        setEvent() {
            $(document).on('click', this.dom.listItemLink, (e) => {
                e.preventDefault();
                const clickIndex = $(e.currentTarget).parent().parent().attr('data-swiper-slide-index');
                if(clickIndex == this.currentIdx) return;
                this.hideContent();
                this.$player.pause();
                this.currentIdx = clickIndex;
                this.setCurrent(this.currentIdx);
                this.hideContent();
                window.setTimeout(() => {this.setContent(this.currentIdx)}, 300);
            });
            this.$player.on('ended', ()=> {
                this.hideContent();
                this.currentIdx++;
                if(this.userMovieData['contents'].length <= this.currentIdx) {
                    this.currentIdx = 0;
                }

                this.setCurrent(this.currentIdx);
                let slideIndex = Math.floor(this.currentIdx / this.$swiper.loopedSlides) * this.$swiper.loopedSlides;
                this.$swiper.slideToLoop(slideIndex);
                window.setTimeout(() => {this.setContent(this.currentIdx)}, 300);
            });
        },
        setContent(idx) {
            var data = this.userMovieData['contents'][idx];

            this.$player = promokit.youtube({
                el: `#${this.$el.id} .sec-movie__video`, youtubeid: data.youtubeId, loop: false, autoplay: true
            });
            this.$player.on('canplay', () => {
                $(this.$el).find('.sec-movie__video').fadeIn(200);
            });
            $(this.$el).find('.sec-movie__video__title').html(data.title);
            $(this.$el).find('.sec-movie__video__link').attr('href', data.link);
            $(this.$el).find('.sec-movie__video__time').html(data.playtime);
            $(this.$el).find('.sec-movie__video__like').html(data.like);
            $(this.$el).find('.sec-movie__video__desc').html(data.desc);
            if(data.profileImg) {
                $(this.$el).find('.sec-movie__video__author__img').attr('src', data.profileImg).show();
                $(this.$el).find('.sec-movie__video__author__name').html(data.profileName).show();
                $(this.$el).find('.sec-movie__video__author__desc').html(data.profileDesc).show();
            } else {
                $(this.$el).find('.sec-movie__video__author__img').hide();
                $(this.$el).find('.sec-movie__video__author__name').hide();
                $(this.$el).find('.sec-movie__video__author__desc').hide();
            }

            $(this.$el).find('.sec-movie__content').fadeIn();
        },
        hideContent() {
            $(this.$el).find('.sec-movie__video').fadeOut(300);
            $(this.$el).find('.sec-movie__content').fadeOut(300);
        },
        setCurrent(idx) {
            $(this.$el).find('.sec-movie__list__item').removeClass('sec-movie__list__item--active');
            $(this.$el).find(`.swiper-slide[data-swiper-slide-index=${idx}]`).addClass('sec-movie__list__item--active');
        },
        openLayer(e) {
            e.preventDefault();
            $(this.$el).find('.sec-movie__layer').show();
        },
        closeLayer(e) {
            e && e.preventDefault();
            $(this.$el).find('.sec-movie__layer').hide();
        },
        clickLayerItem(idx, e) {
            let slideIndex = Math.floor(idx / this.$swiper.loopedSlides) * this.$swiper.loopedSlides;
            this.currentIdx = idx;
            this.$swiper.slideToLoop(slideIndex);
            this.hideContent();
            this.$player.pause();
            this.closeLayer(e);
            this.setCurrent(this.currentIdx);
            window.setTimeout(() => {this.setContent(this.currentIdx)}, 300);
        },
        slidePrev(e) {
            e.preventDefault();
            this.$swiper.slidePrev();
        },
        slideNext(e) {
            e.preventDefault();
            this.$swiper.slideNext();
        }
    }
})

const animation = gsap.timeline({paused: true})
    .addLabel('start')
    .from('#section-5 .sec-common__title', {opacity: 0, duration: .8}, 'start+=0.1')
    .from('#section-5 .sec-common__subtitle', {opacity: 0, duration: .8}, 'start+=0.1')
    .from('#section-5 .sec-movie__content', {opacity: 0, y: 20, duration: .6}, 'start+=0.4')
    .from('#section-5 .sec-movie__list', {opacity: 0, y: 20, duration: .6}, 'start+=0.4')
    .from('#section-5 .sec-movie__arrow', {opacity: 0, y: 20, duration: .6}, 'start+=0.4')
    .from('#section-5 .sec-movie__btn--all', {opacity: 0, y: 20, duration: .6}, 'start+=0.4');

export default {
    id: '#section-5',
    name: '클래식 콘텐츠',
    enterEnd() {
        animation.play();
    },
    leaveEnd() {
        // 떠났을떄 레이어 닫아주기
        userMovie1.closeLayer();
        userMovie1.$player.pause();
        userMovie1.$player.seek(0);
        animation.seek(0).pause();
    },
    enterStart() {
        userMovie1.$player.play();
    }
};



// WEBPACK FOOTER //
// ./src/js/section-5.js